import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/private/Home/Home.jsx";
import Login from "../pages/public/Login/Login.jsx";
import CrearSolicitud from "../pages/private/CrearSolicitud/CrearSolicitud.jsx";
import DetalleOperacion from "../pages/private/DetalleOperacion/DetalleOperacion.jsx";
import Mensajes from "../pages/private/Mensajes/Mensajes.jsx";
//
import CrearAgente from "../pages/private/CrearAgente/CrearAgente.jsx";
import ListadoAgentes from "../pages/private/ListadoAgentes/ListadoAgentes.jsx";
import PerfilAgente from "../pages/private/PerfilAgente/PerfilAgente.jsx";
import Tutoriales from "../pages/private/Tutoriales/Tutoriales.jsx";
//not found
import Error from "../pages/public/Error/Error.jsx";
import { AppContext } from "../context";
import HistoricoGeneralSolicitudes from "../pages/private/HistoricoGeneralSolicitudes/HistoricoGeneralSolicitudes.jsx";
import Dashboard from "../pages/private/Dashboard/Dashboard.jsx";

const ProtectedRoute = ({ authed, children, redirectTo }) => {
  return authed ? children : <Navigate to={redirectTo} />;
};

const PublicRoute = ({ authed, children, redirectTo }) => {
  return !authed ? children : <Navigate to={redirectTo} />;
};

function Users() {
  const { state } = useContext(AppContext);
  const role = localStorage.getItem("role");

  return (
    <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute authed={state.authed} redirectTo="/">
                <Login />
              </PublicRoute>
            }
          />
      { role === "AGA" && (
        <>
          <Route
            path="/"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <Home />
              </ProtectedRoute>
            }
          />
           <Route
            path="/mensajes-notificacion"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <Mensajes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crear-solicitud"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <CrearSolicitud />
              </ProtectedRoute>
            }
          />
          <Route
            path="/detalle-operaciones/:id/"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <DetalleOperacion />
              </ProtectedRoute>
            }
          />
            <Route
            path="/tutoriales"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <Tutoriales />
              </ProtectedRoute>
            }
          />
            <Route
            path="*"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/">
                <Error />
              </ProtectedRoute>
            }
          />
        </>
      )}

      { (role === "ASC" || role === "NUS" ) && (
        <>
      <Route
        path="/"
        element={
          <ProtectedRoute authed={state.authed} redirectTo="/login">
            <ListadoAgentes />
          </ProtectedRoute>
        }
      />
       <Route
            path="/mensajes-notificacion"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <Mensajes />
              </ProtectedRoute>
            }
          />
      <Route
        path="/crear-perfil-agente"
        element={
          <ProtectedRoute authed={state.authed} redirectTo="/login">
            <CrearAgente />
          </ProtectedRoute>
        }
      />
           <Route
          path="/historico-general-solicitudes"
          element={
            <ProtectedRoute authed={state.authed} redirectTo="/login">
              <HistoricoGeneralSolicitudes />
            </ProtectedRoute>
          }
        />
          <Route
            path="/crear-solicitud"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <CrearSolicitud />
              </ProtectedRoute>
            }
          />
      <Route
        path="/perfil-agente/:id"
        element={
          <ProtectedRoute authed={state.authed} redirectTo="/login">
            <PerfilAgente />
          </ProtectedRoute>
        }
      />
        <Route
            path="/perfil-agente/:pa/detalle-operaciones/:id/"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/login">
                <DetalleOperacion />
              </ProtectedRoute>
            }
          />
        <Route
        path="/dashboard"
        element={
          <ProtectedRoute authed={state.authed} redirectTo="/login">
            <Dashboard />
          </ProtectedRoute>
        }
      />
         </>
      )}
        <Route
            path="*"
            element={
              <ProtectedRoute authed={state.authed} redirectTo="/">
                <Error role={role} />
              </ProtectedRoute>
            }
          />
    </Routes>
  );
}

export default Users;
